/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { components } from 'react-select';

import { Typo } from 'uikit/content';

import styles from '../styles/selectOptionWithBody.module.scss';

const SelectOptionWithBody = (props) => {
  const {
    value: { name, body },
  } = props;

  return (
    <components.Option {...props}>
      <div className={styles.element}>
        <Typo element="span" title={name} weight="medium" variant="s02">
          {name}
        </Typo>
        <div className={styles.body}>
          {body && (
            <Typo color="secondary" element="span" title={body} variant="s01">
              {body}
            </Typo>
          )}
        </div>
      </div>
    </components.Option>
  );
};

SelectOptionWithBody.propTypes = {
  value: PropTypes.shape({
    name: PropTypes.string.isRequired,
    body: PropTypes.string,
  }).isRequired,
};

export default SelectOptionWithBody;
